import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import ReactRoutePropTypes from 'react-router-prop-types';
import PropTypes from 'prop-types';
import format from 'date-fns/format';
import {
  communicationFindByIdQuery,
  communicationSaveMutation,
} from '../../../shared/queries/Communication';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../../redux/actions/loadingActions';
import { showNotificationAutoDestroy } from '../../../shared/components/ShowNotification';
import SmartCard from '../../../shared/components/SmartCard';
import GraphQL from '../../../GraphQL';
import CommunicationForm from './Form';
import {
  convertDateToHourStr,
  upLoadFilePromise,
  updatePendency,
} from '../../../shared/utils/smartutils';
import {
  ATTACHMENT_TYPES,
  AVAILABLE_TO,
  COMMUNICATION_TYPE,
  EXAM_TYPE,
} from '../../../shared/utils/constants';
import { useSmartContext } from '../../App/context/SmartProvider';

const CommunicationFormHandler = (props) => {
  const { handlerFileToUploadWithTus, haveFilesToUpload, removeFileByVimeoId } =
    useSmartContext();
  const { match, t, history, dispatch, foreignToggleClose } = props;
  const [dto, setDto] = useState({
    id: 0,
    editable: true,
    files: [],
    scheduledTo: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate(),
      new Date().getHours() + 1,
      0,
      0
    ),
    visibleTo: AVAILABLE_TO.ONLY_RESPONSIBLES,
    examHeader: {
      id: 0,
      weight: 1,
      dueDate: new Date(),
      examType: EXAM_TYPE.NEW,
    },
    occurrenceHeader: { id: 0, occurrenceDate: new Date() },
    htmlContent: '',
  });
  const [type, setType] = useState();
  const [formOn, setFormOn] = useState(false);

  function backClickHandler() {
    if (foreignToggleClose) {
      foreignToggleClose();
    } else {
      history.goBack();
    }
  }

  function showLoading() {
    dispatch(changeLoadingTrue());
  }

  function hideLoading() {
    dispatch(changeLoadingFalse());
  }

  function getTaskHeader(communication) {
    if (communication.taskHeader && communication.taskHeader.id > 0) {
      return {
        ...communication.taskHeader,
        teacher: {
          ...communication.taskHeader.teacher,
          value: communication.taskHeader.teacher.id,
          label: communication.taskHeader.teacher.name,
        },
        subject: {
          ...communication.taskHeader.subject,
          value: communication.taskHeader.subject.id,
          label: communication.taskHeader.subject.name,
        },
      };
    }
    return { id: 0 };
  }

  function getExamHeader(communication) {
    if (communication.examHeader && communication.examHeader.id > 0) {
      return {
        ...communication.examHeader,
        dueDate: new Date(communication.dueDateMili),
        cycle: {
          value: communication.examHeader.cycle,
          label: `${communication.examHeader.cycle}º`,
        },
      };
    }
    return { id: 0 };
  }

  function getOccurrenceHeader(communication) {
    if (
      communication.occurrenceHeader &&
      communication.occurrenceHeader.id > 0
    ) {
      return {
        ...communication.occurrenceHeader,
        occurrenceDate: communication.occurrenceHeader.occurrenceDateMilli
          ? communication.occurrenceHeader.occurrenceDateMilli
          : communication.dueDateMili,
        occurrenceType: {
          ...communication.occurrenceHeader.occurrenceType,
          value: communication.occurrenceHeader.occurrenceType.id,
          label: communication.occurrenceHeader.occurrenceType.name,
        },
      };
    }
    return { id: 0 };
  }

  function findById(id) {
    showLoading();
    const query = communicationFindByIdQuery(id);
    GraphQL(query, {})
      .then((res) => {
        if (
          res.communicationListByFilter &&
          res.communicationListByFilter.length > 0
        ) {
          setDto({
            ...res.communicationListByFilter[0],
            scheduledToDate: res.communicationListByFilter[0].scheduledTo
              ? ` ${format(
                  res.communicationListByFilter[0].scheduledTo,
                  'dd/MM/yyyy'
                )} ${t('general.at')} ${
                  res.communicationListByFilter[0].scheduledToHour
                }`
              : '',
            sentAtDateHour: res.communicationListByFilter[0].sentAt
              ? ` ${format(
                  res.communicationListByFilter[0].sentAt,
                  'dd/MM/yyyy'
                )} ${t('general.at')} ${format(
                  res.communicationListByFilter[0].sentAt,
                  'HH:mm'
                )}  `
              : '',
            taskHeader: getTaskHeader(res.communicationListByFilter[0]),
            occurrenceHeader: getOccurrenceHeader(
              res.communicationListByFilter[0]
            ),
            dueDate: res.communicationListByFilter[0].dueDateMili
              ? new Date(res.communicationListByFilter[0].dueDateMili)
              : null,
            textContent: res.communicationListByFilter[0].htmlContent.replace(
              /<[^>]*>/gi,
              ''
            ),
            examHeader: getExamHeader(res.communicationListByFilter[0]),
          });
        } else {
          showNotificationAutoDestroy(
            'danger',
            t('notifications.error'),
            t('notifications.record-not-found')
          );
          backClickHandler();
        }
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('notifications.find-record-error')
        );
      })
      .finally(() => {
        hideLoading();
      });
  }

  const saveCommunication = (values, uploadedFiles, filesAlreadyToUploaded) => {
    const communication = {
      ...values,
      type,
    };
    const mutation = communicationSaveMutation(
      communication,
      uploadedFiles,
      filesAlreadyToUploaded
    );
    GraphQL(mutation, {
      htmlContent: values.htmlContent,
      textContent: values.textContent,
      title: values.title,
    })
      .then(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-saved')
        );
        backClickHandler();
      })
      .catch(() => {
        if (uploadedFiles && uploadedFiles.length) {
          for (let index = 0; index < uploadedFiles.length; index += 1) {
            const { uploadType, fileId } = uploadedFiles[index];
            if (uploadType === ATTACHMENT_TYPES.VIMEO) {
              removeFileByVimeoId(fileId);
            }
          }
        }
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('errors.error-to-save')
        );
      })
      .finally(() => {
        updatePendency(dispatch);
      });
  };

  const handleSubmit = async (values) => {
    showLoading();
    if (values.files.length > 0) {
      const filesAlreadyToUploaded = values.files.filter(
        (file) => !file.lastModified
      );
      const filesToUpload = values.files.filter(
        (file) =>
          file.lastModified && file.uploadType !== ATTACHMENT_TYPES.VIMEO
      );
      const arrPromises = await filesToUpload.map((file) =>
        upLoadFilePromise(file).then(({ data }) => ({ ...file, ...data }))
      );

      await Promise.all(arrPromises)
        .then(async (uploadedFiles) => {
          const haveVideoFilesToUpload = haveFilesToUpload();
          if (haveVideoFilesToUpload) {
            const listFilesWithVimeoId = await handlerFileToUploadWithTus();
            const uploadedFilesWithVideo = [
              ...uploadedFiles,
              ...listFilesWithVimeoId,
            ];
            saveCommunication(
              values,
              uploadedFilesWithVideo,
              filesAlreadyToUploaded
            );
          } else {
            saveCommunication(values, uploadedFiles, filesAlreadyToUploaded);
          }
        })
        .catch((error) => {
          hideLoading();
          if (error.response) {
            showNotificationAutoDestroy(
              'danger',
              t('notifications.error'),
              t('notifications.upload-error')
            );
          }
        });
    } else {
      const haveVideoFilesToUpload = haveFilesToUpload();
      if (haveVideoFilesToUpload) {
        const listFilesWithVimeoId = await handlerFileToUploadWithTus();
        saveCommunication(values, listFilesWithVimeoId);
      } else {
        saveCommunication(values);
      }
    }
  };

  const updateByOccurrence = (location) => {
    const { state } = location;
    return {
      ...dto,
      occurrenceHeader: {
        id: 0,
        dueDate: new Date(state.event.begin),
        occurrenceHour: convertDateToHourStr(new Date(state.event.begin)),
      },
      dueDate: new Date(state.event.begin),
    };
  };

  const updateByExams = (location) => {
    const { state } = location;
    return {
      ...dto,
      examHeader: {
        id: 0,
        courseStep: state.event.schoolClass.courseStep,
        subject: state.event.subject,
        teacher: state.event.professor,
        dueDate: new Date(state.event.begin),
        examType: EXAM_TYPE.NEW,
      },
      dueDate: new Date(state.event.begin),
    };
  };

  const updateDtoByLocationState = () => {
    const { location } = history;
    if (
      location &&
      RegExp(COMMUNICATION_TYPE.OCCURRENCE).test(location.pathname) &&
      location.state
    ) {
      const updatedDto = updateByOccurrence(location);
      setDto(updatedDto);
    } else if (
      location &&
      RegExp(COMMUNICATION_TYPE.EXAM).test(location.pathname) &&
      location.state
    ) {
      const updatedDto = updateByExams(location);
      setDto(updatedDto);
    }
  };

  useEffect(() => {
    updateDtoByLocationState();
  }, [history]);

  useEffect(() => {
    if (match.params.type) {
      dto.type = match.params.type;
      setType(match.params.type);
    } else {
      setType('POST');
    }
    if (match.params.id && match.params.id > 0) {
      if (dto.id !== parseInt(match.params.id, 0)) {
        findById(match.params.id);
      } else {
        setFormOn(true);
      }
    } else {
      setFormOn(true);
    }
  }, [dto]);

  return (
    <SmartCard
      title={`${t('panels.postagem')} - ${t(`communication.type-${type}`)}`}
    >
      {formOn ? (
        <CommunicationForm
          onSubmit={handleSubmit}
          backHandler={backClickHandler}
          history={history}
          dto={dto}
          type={type}
        />
      ) : null}
    </SmartCard>
  );
};

CommunicationFormHandler.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: ReactRoutePropTypes.history.isRequired,
  match: ReactRoutePropTypes.match.isRequired,
  foreignToggleClose: PropTypes.func,
};

CommunicationFormHandler.defaultProps = {
  foreignToggleClose: null,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(CommunicationFormHandler)
);
